import React, { useState, JSX } from 'react';
import useTranslation from '../../../Hooks/useTranslation';
import fallback from '../../../../_Translations/generated/closure-dates.en.t.json';
import Keys from '../../../../_Translations/generated/closure-dates.en.t.json.keys';
import { Button, Collapse } from 'reactstrap';
import ClosureDates, { ClosureDatesProps } from './ClosureDates';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ClosureDatesCollapse = (props: ClosureDatesProps & { className?: string }): JSX.Element => {
  const { closureDates, className } = props;

  const { t } = useTranslation('closure-dates', fallback, Keys);

  const [isOpen, setIsOpen] = useState(false);

  const toggleFilterState = (): void => {
    const value = !isOpen;
    setIsOpen(value);
  };

  return (
    <div className={'w-100 iso__closure-dates-small-view ' + className || ''}>
      <Button
        className="text-white btn-block my-2 font-weight-bold text-uppercase"
        color="primary"
        onClick={toggleFilterState}
      >
        <div className="justify-content-center">
          <span className="mr-2">{t(Keys.closureDays)}</span>
          <span>
            {!isOpen && <FontAwesomeIcon icon={faAngleDown} className="fas fa-lg" />}
            {isOpen && <FontAwesomeIcon icon={faAngleUp} className="fas fa-lg" />}
          </span>
        </div>
      </Button>
      <Collapse isOpen={isOpen}>
        <ClosureDates closureDates={closureDates} />
      </Collapse>
    </div>
  );
};

export default ClosureDatesCollapse;
